import { render, staticRenderFns } from "./IntegrationBase.vue?vue&type=template&id=2d65d5d4&"
import script from "./IntegrationBase.vue?vue&type=script&lang=js&"
export * from "./IntegrationBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports